import UpdateVersion from '@cobliteam/dashboard/src/components/UpdateVersion';
import { useSidebar } from './Sidebar';

const SidebarUpdate = () => {
  const { state } = useSidebar();
  const isCollapsed = state === 'collapsed';
  return <UpdateVersion sidebarOpen={!isCollapsed} />;
};

export { SidebarUpdate };
